import { render, staticRenderFns } from "./company-info.vue?vue&type=template&id=22eef0ee&scoped=true&"
import script from "./company-info.vue?vue&type=script&lang=js&"
export * from "./company-info.vue?vue&type=script&lang=js&"
import style0 from "./company-info.vue?vue&type=style&index=0&id=22eef0ee&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22eef0ee",
  null
  
)

export default component.exports